
import { supabase } from '@/integrations/supabase/client';
import { UserRole } from '@/types/user-roles';

export interface SignUpData {
  firstName: string;
  lastName: string;
  role: UserRole;
}

export const signUp = async (
  email: string,
  password: string,
  userData: SignUpData
) => {
  return await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        first_name: userData.firstName,
        last_name: userData.lastName,
        role: userData.role
      }
    }
  });
};

export const signIn = async (email: string, password: string) => {
  return await supabase.auth.signInWithPassword({
    email,
    password
  });
};

export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    return { error: null };
  } catch (error: any) {
    console.error("Error during signout:", error.message);
    return { error };
  }
};

export const getCurrentUser = async () => {
  const { data } = await supabase.auth.getUser();
  return data.user;
};

export const getUserProfile = async (userId: string) => {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
    
  if (error) throw error;
  return data;
};

export const getPEOVerificationStatus = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from('peo_verifications')
      .select('status')
      .eq('user_id', userId)
      .single();
      
    if (error) throw error;
    return data?.status || 'pending';
  } catch (error) {
    console.error("Error checking PEO verification status:", error);
    return 'error';
  }
};
